/* One capture handler owned by the buybox; no global Debutify reinitialisation. */
window.NextBottleCart = window.NextBottleCart || async function(box, event) {
  const form = event.target;
  if (!form.matches('form')) return;
  const useDrawer = ['drawer', 'modal'].includes(window.theme?.settings?.cartType) && typeof window.theme?.ajaxCart?.update === 'function';
  event.preventDefault();
  event.stopImmediatePropagation();
  const id = form.querySelector('[name="id"]');
  const button = form.querySelector('[type="submit"]');
  if (box.adding || box.loading || box.failed || !id?.value || id.disabled || !button || button.disabled) return;
  const endpoint = new URL(form.dataset?.nbCartAddUrl || form.action, location.origin);
  if (endpoint.origin !== location.origin || !endpoint.pathname.endsWith('/cart/add')) return;
  endpoint.pathname += '.js';
  // Native offers carry only the selected Shopify variant and one offer unit.
  // Do not forward hidden fields injected by unrelated product-form apps.
  const payload = new URLSearchParams({id: id.value, quantity: '1'});
  const pageStatus = box.querySelector('[data-nb-status]');
  if (pageStatus) pageStatus.textContent = '';
  let status = form.querySelector('[data-nb-cart-status]');
  if (!status) {
    status = document.createElement('p');
    status.setAttribute('data-nb-cart-status', '');
    status.setAttribute('role', 'status');
    status.setAttribute('aria-live', 'polite');
    status.style.cssText = 'margin:10px 0;font-size:14px;line-height:1.5';
    button.before(status);
  }
  const panel = box.querySelector('[data-nb-panel]');
  const fields = Array.from(form.querySelectorAll('fieldset'));
  const previousDisabled = fields.map(field => field.disabled);
  box.adding = true;
  panel.setAttribute('aria-busy', 'true');
  button.disabled = true;
  fields.forEach(field => { field.disabled = true; });
  status.textContent = 'Wird in den Warenkorb gelegt …';
  const controller = new AbortController();
  const timeout = setTimeout(() => controller.abort(), 30000);
  let postStarted = false;
  let added = false;
  let rejected = false;
  try {
    // Revalidate stale pages against Shopify before mutating the cart.
    const state = box.querySelector('[data-nb-offer-state]');
    const checkUrl = new URL(state?.dataset.productUrl || '', location.origin);
    if (!state?.dataset.productUrl || checkUrl.origin !== location.origin) throw new Error('Auswahl konnte nicht geprüft werden. Bitte wähle dein Angebot erneut.');
    checkUrl.searchParams.set('variant', id.value);
    checkUrl.searchParams.set('section_id', 'nextbottle-offer-state');
    const checkResponse = await fetch(checkUrl, {credentials:'same-origin',cache:'no-store',signal:controller.signal});
    if (!checkResponse.ok) throw new Error('Verfügbarkeit konnte nicht geprüft werden. Bitte wähle dein Angebot erneut.');
    const checked = new DOMParser().parseFromString(await checkResponse.text(), 'text/html').querySelector('[data-nb-offer-state]');
    if (!checked || checked.dataset.variantId !== id.value || new URL(checked.dataset.productUrl, location.origin).pathname !== checkUrl.pathname) throw new Error('Auswahl konnte nicht bestätigt werden. Bitte wähle dein Angebot erneut.');
    if (checked.querySelector('[type="submit"]')?.disabled !== false) throw new Error('Diese Farbkombination ist inzwischen ausverkauft. Bitte wähle eine andere Farbe.');
    if (checked.dataset.priceCents !== state.dataset.priceCents || checked.dataset.currency !== state.dataset.currency) throw new Error('Der Preis hat sich geändert. Bitte wähle dein Angebot erneut.');
    postStarted = true;
    const response = await fetch(endpoint, {method:'POST',body:payload,headers:{Accept:'application/json'},credentials:'same-origin',signal:controller.signal});
    if (!response.ok) {
      // Only a clear validation rejection is safe to retry without checking cart.
      rejected = response.status === 422;
      const data = await response.json();
      throw new Error(data.description || 'Die Auswahl konnte nicht hinzugefügt werden.');
    }
    added = true;
    clearTimeout(timeout);
    if (!useDrawer) {
      location.assign(endpoint.pathname.replace(/\/add\.js$/, ''));
      return;
    }
    window.initNotificationToast = false;
    await new Promise((resolve, reject) => {
      const timer = setTimeout(() => reject(new Error('Cart refresh timed out')), 10000);
      try { window.theme.ajaxCart.update(() => { clearTimeout(timer); resolve(); }); }
      catch (error) { clearTimeout(timer); reject(error); }
    });
    status.textContent = 'Im Warenkorb hinzugefügt.';
  } catch (error) {
    if (added) {
      // The item is already added: navigate without a second POST.
      location.assign(endpoint.pathname.replace(/\/add\.js$/, ''));
    } else if (!postStarted) {
      box.failed = true;
      status.textContent = error.name === 'AbortError' ? 'Verfügbarkeit konnte nicht geprüft werden. Bitte wähle dein Angebot erneut.' : error.message;
    } else if (rejected) {
      status.textContent = error.message;
      if (/ausverkauft|sold out/i.test(error.message)) {
        box.failed = true;
        button.textContent = 'Zurzeit nicht verfügbar';
        const stock = form.querySelector('[data-nb-stock-status]');
        if (stock) {
          stock.textContent = 'Diese Farbkombination ist zurzeit nicht verfügbar.';
          stock.className = 'nb-stock-status nb-stock-status--unavailable';
        }
        status.textContent += ' Bitte wähle eine andere Farbkombination.';
      }
    } else {
      box.failed = true;
      status.textContent = 'Die Bestätigung fehlt. Bitte prüfe zuerst deinen Warenkorb, bevor du erneut kaufst. ';
      const link = document.createElement('a');
      link.href = endpoint.pathname.replace(/\/add\.js$/, '');
      link.textContent = 'Warenkorb prüfen';
      status.append(link);
    }
    if (!added) status.scrollIntoView({block:'center',behavior:'auto'});
  } finally {
    clearTimeout(timeout);
    box.adding = false;
    panel.removeAttribute('aria-busy');
    fields.forEach((field, index) => { field.disabled = previousDisabled[index]; });
    button.disabled = !!box.failed;
  }
};
